import actionTypes from './actionTypes';

export default {
  [actionTypes.SET_COUPON_START]: () => ({
    type: actionTypes.SET_COUPON_START,
  }),
  [actionTypes.SET_COUPON_SUCCESS]: () => ({
    type: actionTypes.SET_COUPON_SUCCESS,
  }),
  [actionTypes.SET_COUPON_FAIL]: (errorArg, discountCode) => {
    const err = errorArg ? { ...errorArg } : {};
    if (!err.couponErrorMessageKey) {
      err.couponErrorMessageKey = 'invalidPromoCode';
    }
    err.couponErrorSubstitutions = { promoCode: discountCode };
    return {
      type: actionTypes.SET_COUPON_FAIL,
      error: err,
    };
  },
  [actionTypes.CLEAR_COUPON_START]: () => ({
    type: actionTypes.CLEAR_COUPON_START,
  }),
  [actionTypes.CLEAR_COUPON_SUCCESS]: () => ({
    type: actionTypes.CLEAR_COUPON_SUCCESS,
  }),
  [actionTypes.CLEAR_COUPON_FAIL]: error => ({
    type: actionTypes.CLEAR_COUPON_FAIL,
    error,
  }),
};
